import { ROLES, PERMISSIONS, PERMISSIONS_NEW, VERTICALS, DIVISION } from "../util/constants"
import { loginStore, RolesStore } from "../state/CommonState"
import { ServerLists } from "../StaticData";
class RoleUtils {

  static isUserAuthorizedOld(permissionToCheck) {
    let user = loginStore.userRec.aguserRec;
    let userRoles = user?.role;
    let userRolesIDs = user?.role;
    const userVertical = user?.vertical;
    const userDivision = user?.division;
    const rolePermissionList = ServerLists?.rolePermissionsList
    const rolesList = ServerLists?.rolesList

    const isAuthorized = (role, vertical) => {
      const permission = rolePermissionList.find(item => item?.permission_name === permissionToCheck);

      if (!permission) return false;
      return permission.roles.some(permittedRole => {
        if (
          (permissionToCheck === PERMISSIONS.NAV_MENU.CROSS_BORDER ||
            permissionToCheck === PERMISSIONS.EDIT.Razor_Pay) &&
          role === permittedRole.role
        ) {
          return true;
        }
        return role === permittedRole.role && vertical === permittedRole.vertical;
      })
    }

    const modifyUserRole = (role, division, vertical) => {
      if ((role === ROLES.CB.ADMIN && division === DIVISION.REGIONAL && vertical === VERTICALS.CROSS_BORDER) ||
        (role === ROLES.CB.ADMIN && division === DIVISION.ZONAL && vertical === VERTICALS.CROSS_BORDER)) {
        return ROLES.CB.BRANCH_HEAD;
      } else if ((role === ROLES.DT.ADMIN && division === DIVISION.REGIONAL && vertical === VERTICALS.DOMESTIC_TRANSPORT) ||
        (role === ROLES.DT.ADMIN && division === DIVISION.ZONAL && vertical === VERTICALS.DOMESTIC_TRANSPORT)) {
        return ROLES.DT.BRANCH_HEAD;
      }
      return role;
    }

    const rolesMap = rolesList.reduce((map, role) => {
      map[role._id] = role.roleName;
      return map;
    }, {})

    for (const userRole of userRoles) {
      const roleName = rolesMap[userRole] || userRole;
      const modifiedRole = modifyUserRole(roleName, userDivision, userVertical);
      // const modifiedRole = modifyUserRole(userRole, userDivision, userVertical);
      if (isAuthorized(modifiedRole, userVertical)) {
        return true;
      }
    }

    return false;
  }
  static isUserAuthorized(permissionToCheck) {
    return ServerLists?.rolePermissionsList?.includes(permissionToCheck) ?? false
  }

  // Booking view (after the booking is placed): Cost / Revenue Details sections follow the role
  // permissions (Roles & Permissions → Bookings).
  static canViewBookingCostDetails() {
    return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.COST_DETAILS)
  }

  static canViewBookingRevenueDetails() {
    return RoleUtils.isUserAuthorized(PERMISSIONS_NEW.BOOKINGS.REVENUE_DETAILS)
  }

  // Column for the Cost / Revenue Details buttons: half width when both show, full width when only one does
  static bookingDetailsColumnClass() {
    return RoleUtils.canViewBookingCostDetails() && RoleUtils.canViewBookingRevenueDetails() ? 'column is-6' : 'column is-12'
  }

  static getUserRole = () => {
    const userRec = loginStore.userRec.aguserRec
    return userRec.role
  }
}

export default RoleUtils
